import { Tab, Tabs, TabList, TabPanel } from "react-tabs";

const BenefitContent = () => {
  return (
    <Tabs>
      <div className="lg:flex lg:flex-nowrap lg:space-x-10 benifit">
        <div className="lg:w-[43%]">
          {/* <!-- tabs --> */}

          <TabList className="nav nav-tabs mb-12 space-y-2">
            <Tab className="nav-item">
              <button
                className="nav-link nav-link--style-2  group relative flex w-full border-jacarta-100 p-6 text-left dark:border-jacarta-600 dark:bg-transpare"
                type="button"
              >
              
                <div>
                  <span className="mb-2 mt-1 block font-display text-xl font-medium group-hover:text-accent dark:text-white transition transition-colors">
                    Use Case
                  </span>
                  <div className="nav-link-content hidden">
                    <p className="text-jacarta-500 dark:text-jacarta-300">
                      VS Token can be used for things within the VirtueSekai ecosystem (usecases below) and is also a presale token for Platinum our in game premium currency. 50% of Proceeds made go to Liquidity pool for Platinum and 50% used for development of VirtueSekai.
                    </p>
                  </div>
                </div>
              </button>
            </Tab>
            {/* End tab */}

            <Tab className="nav-item">
              <button
                className="nav-link nav-link--style-2 group relative flex w-full border-b border-jacarta-100 p-6 text-left dark:border-jacarta-600"
                type="button"
              >
            

                <div>
                  <span className="mb-2 mt-1 block font-display text-xl font-medium text-jacarta-700 group-hover:text-accent dark:text-white transition transition-colors">
                    NFT Minting at a discount
                  </span>
                  <div className="nav-link-content hidden">
                    <p className="text-jacarta-500 dark:text-jacarta-300">
                      Using VS Token to mint our NFTs allows the user to save 10% on mint cost per NFT.
                    </p>
                  </div>
                </div>
              </button>
            </Tab>
            {/* End tab */}

            <Tab className="nav-item">
              <button
                className="nav-link nav-link--style-2 group relative flex w-full border-b border-jacarta-100 p-6 text-left dark:border-jacarta-600"
                type="button"
              >
               

                <div>
                  <span className="mb-2 mt-1 block font-display text-xl font-medium text-jacarta-700 group-hover:text-accent dark:text-white transition transition-colors">
                    Airdrop
                  </span>
                  <div className="nav-link-content hidden">
                    <p className="text-jacarta-500 dark:text-jacarta-300">
                      Holders of VS Token will be airdropped an equal amount of Platinum, our premium in game currency for the VirtueSekai game, after our snapshopt is taken closer to game release.
                    </p>
                  </div>
                </div>
              </button>
            </Tab>
            {/* End tab */}

            <Tab className="nav-item">
              <button
                className="nav-link nav-link--style-2 group relative flex w-full border-b border-jacarta-100 p-6 text-left dark:border-jacarta-600"
                type="button"
              >
              

                <div>
                  <span className="mb-2 mt-1 block font-display text-xl font-medium text-jacarta-700 group-hover:text-accent dark:text-white transition transition-colors">
                    Backer NFT
                  </span>
                  <div className="nav-link-content hidden">
                    <p className="text-jacarta-500 dark:text-jacarta-300">
                      By holding any amount of VS Token during our snapshot will guarantee you an NFT commemorating your support towards VirtueSekai development.
                    </p>
                  </div>
                </div>
              </button>
            </Tab>
            {/* End tab */}

            <Tab className="nav-item">
              <button
                className="nav-link nav-link--style-2 group relative flex w-full border-b border-jacarta-100 p-6 text-left dark:border-jacarta-600"
                type="button"
              >
              

                <div>
                  <span className="mb-2 mt-1 block font-display text-xl font-medium text-jacarta-700 group-hover:text-accent dark:text-white transition transition-colors">
                    Voting
                  </span>
                  <div className="nav-link-content hidden">
                    <p className="text-jacarta-500 dark:text-jacarta-300">
                      During development of the VirtueSekai game you will have power to vote on what features come first to the game by using your VS Token!
                    </p>
                  </div>
                </div>
              </button>
            </Tab>
          </TabList>
        </div>
        {/* End tablist */}

        <div className="flex items-center hidden lg:block lg:pt-16 justify-center lg:w-[57%]">
          {/* <!-- content --> */}
          <div className="tab-content flex-1">
            <TabPanel>
              <div className=" relative">
                <figure className="flex items-center justify-center">
                  <img
                    src="/images/coins/discord.png"
                    alt="benifit"
                    className="rounded-full bg-jacarta-600 p-3 dark:border-jacarta-600"
                  />
                </figure>
              </div>
            </TabPanel>

            <TabPanel>
              <div className="relative">
                <figure className="flex items-center justify-center">
                   <img
                    src="/images/coins/discord.png"
                    alt="benifit"
                    className="rounded-full bg-jacarta-600 p-3 dark:border-jacarta-600"
                  />
                </figure>
              </div>
            </TabPanel>
            <TabPanel>
              <div className="relative">
                <figure className="flex items-center justify-center">
                    <img
                    src="/images/coins/discord.png"
                    alt="benifit"
                    className="rounded-full bg-jacarta-600 p-3 dark:border-jacarta-600"
                  />
                </figure>
              </div>
            </TabPanel>
            <TabPanel>
              <div className="relative">
                <figure className="flex items-center justify-center">
                   <img
                    src="/images/coins/discord.png"
                    alt="benifit"
                    className="rounded-full bg-jacarta-600 p-3 dark:border-jacarta-600"
                  />
                </figure>
              </div>
            </TabPanel>
            <TabPanel>
              <div className=" relative">
                <figure className="flex items-center justify-center">
                   <img
                    src="/images/coins/discord.png"
                    alt="benifit"
                    className="rounded-full bg-jacarta-600 p-3 dark:border-jacarta-600"
                  />
                </figure>
              </div>
            </TabPanel>
          </div>
        </div>
      </div>
    </Tabs>
  );
};

export default BenefitContent;
